"use client";

import React from "react";
import { motion } from "framer-motion";

export const HeroScrollIndicator: React.FC = () => {
  const handleScroll = () => {
    window.scrollTo({
      top: window.innerHeight - 70,
      behavior: "smooth",
    });
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 1.2, duration: 1.0, ease: [0.16, 1, 0.3, 1] }}
      className="absolute bottom-7 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center cursor-pointer select-none group opacity-60 hover:opacity-90 transition-opacity duration-300"
      onClick={handleScroll}
    >
      <span className="font-sans font-medium text-[9px] text-white/35 tracking-[0.22em] uppercase mb-2 group-hover:text-white/70 transition-colors duration-300">
        Scroll to Explore
      </span>

      {/* Slim, Minimal Mouse Outline */}
      <div className="w-4.5 h-7.5 border border-white/15 rounded-full flex justify-center p-1 backdrop-blur-[1px] bg-white/[0.01] group-hover:border-white/30 transition-colors duration-300">
        {/* Subtle Animated Scroll Dot */}
        <motion.div
          animate={{
            y: [0, 8, 0],
            opacity: [0.3, 0.7, 0.3],
          }}
          transition={{
            duration: 2.4,
            repeat: Infinity,
            ease: "easeInOut",
          }}
          className="w-1 h-1.5 rounded-full bg-white/70"
        />
      </div>
    </motion.div>
  );
};

export default HeroScrollIndicator;
